import { formatNumber } from "devextreme/localization";

export default function AssetsTitle({ total }: { total: number }) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <span className="text-base font-medium text-neutral-100 sm:text-lg">Assets</span>
      </div>
      <span className="text-base font-medium text-neutral-100 sm:text-lg">
        Total Asset Balance: {formatNumber(total ?? 0, "currency")}
      </span>
    </div>
  );
}
